import React from 'react';
import { useDetailsModal } from '../context/DetailsModalContext';
import { LINK_TEXT } from '../utils/clickable';

// A repayment (its amount, date or reference) that opens the repayment's quick
// view. Pass the repayment row when it is on screen, or just its id. A client
// only ever opens their own (the API refuses the rest).
const RepaymentLink = ({ repayment, repaymentId, children, className = '', title }) => {
  const { openRepayment, canViewRepayments } = useDetailsModal();
  const id = repayment?.id ?? repayment?.repayment_id ?? repaymentId;
  const label = children ?? (id ? `Repayment #${id}` : '-');
  if (!id || !canViewRepayments) return <span className={className}>{label}</span>;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        openRepayment(repayment || id);
      }}
      className={`${LINK_TEXT} text-left p-0 bg-transparent border-0 ${className}`}
      title={title || 'Open repayment details'}
    >
      {label}
    </button>
  );
};

export default RepaymentLink;
